function setupGlobalErrorHandlers(): void {
  globalThis.onerror = (message, source, lineno, colno, error) => {
    const normalizedError = error ?? new Error(typeof message === 'string' ? message : 'Script error');
    console.error("[JS_EXCEPTION]", normalizedError, { source, lineno, colno });
    globalThis.dtrum?.reportError(normalizedError instanceof Error ? normalizedError : new Error(String(normalizedError)));
  };

  globalThis.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const normalizedError = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    console.error("[UNHANDLED_REJECTION]", normalizedError);
    globalThis.dtrum?.reportError(normalizedError);
  });
}

export { setupGlobalErrorHandlers };
